module.exports = __webpack_public_path__ + "img/fen-close.a6ee1d1b.svg";